/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyExecuteServiceAccount {
    getFixupPrototypeFunction() { return PolicyExecuteServiceAccount.fixupPrototype; }

    static newInstance(model: Partial<PolicyExecuteServiceAccount>): PolicyExecuteServiceAccount {
        let obj = Object.assign(new PolicyExecuteServiceAccount(), model);
        PolicyExecuteServiceAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyExecuteServiceAccount>): PolicyExecuteServiceAccount {
        if (!model) return null;
        return PolicyExecuteServiceAccount.newInstance(<PolicyExecuteServiceAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyExecuteServiceAccount) {
        if (!obj) return;

        models.PolicyExecuteServiceAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyExecuteServiceAccount): boolean {
        Object.setPrototypeOf(obj, PolicyExecuteServiceAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Identifier of the cloud account to execute the policy against
     */
    service_account_id: string;

    /**
     * The region of the cloud account where the policy needs to be executed. If not provided, the policy will execute across preferred regions
     */
    region: string;

    /**
     * Resource group for which the policy needs to be executed. Applicable only for Azure cloud accounts
     */
    resourcegroup: string;

}
